import React from "react";
import styles from "./CenteredPopUp.module.css";
import { pushToGA } from "../../Services/users";
import { connect } from "react-redux";

interface CenteredPopUpProps {
  setModal: (open: boolean) => void;
  children: React.ReactNode;
  modiferClass?: string; 
  closeIcon: boolean;
  closeClassMofifier?:any;
  popupName?:string;
  user?: any,
  // closeIconClass?: string; 
}

const CenteredPopUp: React.FC<CenteredPopUpProps> = ({
  setModal,
  children,
  modiferClass = "",
  closeIcon,
  closeClassMofifier,
  popupName,
  user,
  // closeIconClass,
}) => {
  const closeModal = () => {
    setModal(false);
    document.body.classList.remove("no-overflow");
    if (popupName && popupName === "Whatsapp_Marketing") {
      pushToGA(
        "event_tracking",
        "read pro",
        "read pro",
        "whatsapp popup | cta :Close click",
        user,
        // eventLabel ? eventLabel : ""
      )
    }
  };

  return (
    <>
      <div className={styles.CenteredPopup}>
        <div className={`${styles.CenteredPopupContent} ${modiferClass}`}>
          {closeIcon && <div className={`${styles.CenteredPopupClose} ${closeClassMofifier}`} onClick={closeModal}></div>}
          {/* {closeIcon && <div className={`${styles.CenteredPopupClose} ${closeIconClass}`} onClick={closeModal}></div>} */}
          {children}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
  };
};

export default connect(mapStateToProps)(CenteredPopUp);